import React, { useEffect, useRef, useState } from 'react'
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from 'react-hook-form';
import ApiHelper from '../../helperFunction/ApiHelper';
import API_ENDPOINTS from '../../helperFunction/Constant';
import { Toast } from 'primereact/toast';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Layout from '../common/Layout';

const AddSectionScores = () => {

    const { quizId, sectionId, id } = useParams()
    const isEdit = id ? true : false
    const toast = useRef(null)

    const navigate = useNavigate()

    useEffect(() => {
        isEdit && getQuizScores()
    }, [])

    const schema = yup.object({
        sectionResultId: yup.string().optional().nullable(), 
        quizId: yup.string().optional().nullable(), 
        sectionId: yup.string().optional().nullable(), 
        resultName: yup.string().required("Name is required"),
        resultDescription: yup.string().required("Description is required"),
        minMarks: yup.number().transform((value, originalValue) => (originalValue === "" || isNaN(originalValue)) ? null : value).nullable().required("Min Marks is required"),
        maxMarks: yup.number().transform((value, originalValue) => (originalValue === "" || isNaN(originalValue)) ? null : value).nullable().required("Max Marks is required"),
        type: yup.string().required("Type is required"),
        isActive: yup.boolean(),
    });

    const { register, handleSubmit, reset, formState: { errors }, } = useForm({ resolver: yupResolver(schema), });

    const resetValue = () => {
        reset({
            sectionResultId: null,
            quizId: null,
            sectionId: null,
            resultName: '',
            resultDescription: '',
            minMarks: '',
            maxMarks: '',
            type: '',
            isActive: false,
        })
    }

    const getQuizScores = () => {
        ApiHelper.get(`${API_ENDPOINTS.SECTION_SCORES}/edit/${id}`).then((res) => {
            console.log('res:', res);
            if (res.status === 200) {
                reset({
                    sectionResultId: res.data.data.sectionResultId,
                    resultName: res.data.data.resultName,
                    resultDescription: res.data.data.resultDescription,
                    minMarks: res.data.data.minMarks,
                    maxMarks: res.data.data.maxMarks,
                    type: res.data.data.type,
                    isActive: res.data.data.isActive,
                })
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };
    
    const onSubmit = (data) => {
        data.sectionId = sectionId
        data.quizId = quizId
        if (data.sectionResultId) {
            update(data, data.sectionResultId)
        } else {
            add(data)
        }
    };

    const add = (data) => {
        ApiHelper.post(`${API_ENDPOINTS.SECTION_SCORES}/${sectionId}`, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                setTimeout(() => {
                    navigate(-1)
                }, 1000)
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };

    const update = (data, sectionResultId) => {
        ApiHelper.put(`${API_ENDPOINTS.SECTION_SCORES}/edit/${sectionResultId}`, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                setTimeout(() => {
                    navigate(-1)
                }, 1000)
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };

  return (
    <>
        <Toast ref={toast} />
        <Layout>
            <div class="content-wrapper">
                <div class="container-xxl flex-grow-1 container-p-y">
                    <div class="d-flex justify-content-between align-items-center py-3">
                        <h4 class="fw-bold py-3 mb-2">
                            <span class="d-flex text-muted fw-light"> 
                                <p class="breadcrumb-item pageHeader active me-2 mb-0" aria-current="page" onClick={() => navigate(`/quiz/${quizId}/section/${sectionId}/scores`)}> Manage Results </p> / <b className='mx-2'> {isEdit ? 'Edit' : "Add"} </b>
                            </span>
                        </h4>
                        <Link to={`/quiz/${quizId}/section/${sectionId}/scores`} class="btn btn-secondary">⬅ Go Back</Link>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card mb-4">
                                <div class="card-body">
                                    <div>
                                        <form onSubmit={handleSubmit(onSubmit)}>
                                            <div class="row mb-3">
                                                <div class="col-md-3 mb-3">
                                                    <label class="form-label">Name</label>
                                                    <input type="text" name="resultName" class="form-control" {...register("resultName")} />
                                                    <small className="text-danger">{errors.resultName?.message}</small>
                                                </div>
                                                <div class="col-md-9 mb-3">
                                                    <label class="form-label">Description</label>
                                                    <textarea type="text" name="resultDescription" class="form-control" {...register("resultDescription")}></textarea>
                                                    <small className="text-danger">{errors.resultDescription?.message}</small>
                                                </div>
                                                <div class="col-md-3 mb-3">
                                                    <label class="form-label">Minmum Marks</label>
                                                    <input type="number" name="minMarks" onKeyDown={(e) => { if (['e', 'E', '+', '-'].includes(e.key)) { e.preventDefault(); } }} class="form-control" {...register("minMarks")} />
                                                    <small className="text-danger">{errors.minMarks?.message}</small>
                                                </div>
                                                <div class="col-md-3 mb-3">
                                                    <label class="form-label">Maximum Marks</label>
                                                    <input type="number" name="maxMarks" onKeyDown={(e) => { if (['e', 'E', '+', '-'].includes(e.key)) { e.preventDefault(); } }} class="form-control" {...register("maxMarks")} />
                                                    <small className="text-danger">{errors.maxMarks?.message}</small>
                                                </div>
                                                <div class="col-md-3 mb-3">
                                                    <label class="form-label">Score Type</label>
                                                    <select id="mySelect" {...register('type')} class="form-select" >
                                                        <option value="">Select Result Type</option>
                                                        <option value="red">Red</option>
                                                        <option value="yellow">Yellow</option>
                                                        <option value="green">Green</option>
                                                    </select>
                                                    <small className="text-danger">{errors.type?.message}</small>
                                                </div>
                                                <input type='hidden' {...register("sectionResultId")}/>
                                            </div>
                                            <div class="mt-4 mb-3">
                                                <button type="submit" class="btn btn-primary me-3">Save</button>
                                                <button type="button" onClick={() => resetValue()} class="btn btn-secondary reset-btn">Reset</button>
                                            </div>
                                        </form> 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    </>
  )
}

export default AddSectionScores
